<script setup lang="ts">
import ClinicalMasterDataWorkspace from "@/components/healthcare/master-data/ClinicalMasterDataWorkspace.vue";

definePage({
  meta: {
    navActiveLink: "healthcare-clinical-master-data",
    permissionKey: "page.healthcare.clinical_master_data",
  },
});
</script>

<template>
  <ClinicalMasterDataWorkspace />
</template>
